import { useYearQuarterNavigation } from 'hooks';
import { useTranslation } from 'react-i18next';

import {
  AbsenceTypeFormation,
  AdditionalFormationCategory,
  EmployeeFormation
} from 'components/types';

import { Table, TableBody, TableCell, TableHead } from '@mui/material';

import { NumericTableCell, TableHeaderRow } from 'components/shared/Table';

import {
  isFormationAbsenceTypeFormation,
  isFormationAdditionalTypeFormation,
  renderFixedTableHeaderForFormationDetail,
  renderPeriodColumnHeaders
} from '../../util';
import DetailRow from './DetailRow';

type Props = {
  formations:
    | EmployeeFormation[]
    | AdditionalFormationCategory[]
    | AbsenceTypeFormation[];
  shouldShowExcludeOption?: boolean;
};

const DetailTable = ({ formations, shouldShowExcludeOption }: Props) => {
  const { t } = useTranslation('common');
  const { isViewPerWeek } = useYearQuarterNavigation();
  const { periodHours } = formations[0];

  return (
    <Table stickyHeader size="small">
      <TableHead>
        <TableHeaderRow>
          <NumericTableCell
            width={isFormationAdditionalTypeFormation(formations[0]) ? 70 : 16}
          />
          {!isFormationAbsenceTypeFormation(formations[0]) && (
            <>
              {shouldShowExcludeOption && <TableCell />}
              {!isFormationAdditionalTypeFormation(formations[0]) && (
                <TableCell>{t('employeeName')}</TableCell>
              )}
              <TableCell
                sx={{
                  minWidth: '8px',
                  width: '8px',
                  padding: 0
                }}
              />
              <TableCell>{t('function')}</TableCell>
            </>
          )}
          {renderFixedTableHeaderForFormationDetail(formations[0])}
          {renderPeriodColumnHeaders(periodHours, isViewPerWeek)}
          <NumericTableCell width={68}>{t('formation.total')}</NumericTableCell>
          <NumericTableCell width={68}>%</NumericTableCell>
        </TableHeaderRow>
      </TableHead>
      <TableBody>
        {formations.map((formation) => {
          const rowStyle =
            formation.excludedFromScenario ||
            (formation.function && formation.function.excluded)
              ? { opacity: 0.6 }
              : {};

          return (
            <DetailRow
              style={rowStyle}
              key={formation.uuid}
              formation={formation}
              shouldShowExcludeOption={shouldShowExcludeOption}
            />
          );
        })}
      </TableBody>
    </Table>
  );
};

export default DetailTable;
